import type { RouteAccessRule } from './routeAccess.types';
import buildRosieRouteAccessRules from './buildRosieRouteAccessRules';

export {
  ADMIN_ONLY_USER_TYPES,
  STAFF_USER_TYPES,
  ROSIE_SESSION_USER_TYPES,
} from './routeAccess.userTypes';

export const DEFAULT_DENIED_REDIRECT = '/dashboard';

/**
 * Path-prefix access rules (nav + RouteAccessGuard). Built from shared nav tree
 * data + supplemental routes; longest prefix wins — see `matchRuleForPath`.
 */
export const ROUTE_ACCESS_RULES: RouteAccessRule[] =
  buildRosieRouteAccessRules();

export const STAFF_FALLBACK_RULE: RouteAccessRule =
  ROUTE_ACCESS_RULES.find(r => r.id === 'staff')!;
